import { createFileRoute, Link } from "@tanstack/react-router";
import { Section } from "@/components/site/Section";
import { faqs, faqHeading, faqIntro } from "@/content/faq";
import { SITE_URL } from "@/lib/seo";

const title = "Frequently Asked Questions | Leadership Edge Live";
const description =
  "Straight answers about Leadership Edge Live, including what you will see in 90 days, time commitment, and pricing.";

export const Route = createFileRoute("/faq")({
  head: () => ({
    links: [{ rel: "canonical", href: `${SITE_URL}/faq/` }],
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: FaqPage,
});

function FaqPage() {
  return (
    <Section tone="default" paddingClassName="pt-32 pb-20 md:pt-36 md:pb-28">
      <div className="mx-auto max-w-3xl">
        <h1 className="text-3xl font-semibold leading-tight text-ink md:text-5xl">{faqHeading}</h1>
        <p className="mt-4 text-base leading-relaxed text-muted-foreground">{faqIntro}</p>
        <ol className="mt-12 divide-y divide-border/60 border-y border-border/60">
          {faqs.map((f, i) => (
            <li key={f.question} className="py-8">
              <h2 className="flex gap-4 text-xl font-semibold leading-snug text-ink md:text-2xl">
                <span className="text-primary">{String(i + 1).padStart(2, "0")}.</span>
                <span>{f.question}</span>
              </h2>
              <p className="mt-4 text-base leading-relaxed text-muted-foreground md:pl-12">
                {f.answer}
              </p>
            </li>
          ))}
        </ol>
        <div className="mt-12 flex flex-wrap gap-4">
          <Link
            to="/contact/"
            className="inline-flex items-center rounded-[6px] bg-[#693D94] px-6 py-3 text-sm font-semibold text-primary-foreground shadow-brand"
          >
            Talk to a Development Pro
          </Link>
        </div>
      </div>
    </Section>
  );
}
